import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const BrandAttributeSchema = z.object({
  _id: objectIdSchema,
  name: z.string().optional(),
  iconUrl: z.string().optional(),
});
